import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";

interface RestaurantNameFieldProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const RestaurantNameField = ({ form }: RestaurantNameFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Restaurant Name</FormLabel>
          <FormControl>
            <Input {...field} placeholder="Enter restaurant name" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};